import { render, staticRenderFns } from "./create.vue?vue&type=template&id=724c19e4&"
import script from "./create.js?vue&type=script&lang=js&"
export * from "./create.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports